import React from 'react';
import {
    Button,
    Dialog,
    DialogActions,
    DialogContent,
    DialogContentText,
    DialogTitle,
} from '@mui/material';

const DeleteConfirmationDialog = ({ open, itemName, onClose, onConfirm }) => (
    <Dialog open={open} onClose={onClose} aria-labelledby="delete-confirmation-title">
        <DialogTitle id="delete-confirmation-title">Confirm deletion</DialogTitle>
        <DialogContent>
            <DialogContentText>
                Are you sure you want to delete {itemName || 'this item'}? This action cannot be undone.
            </DialogContentText>
        </DialogContent>
        <DialogActions>
            <Button onClick={onClose} color="inherit">
                Cancel
            </Button>
            <Button onClick={onConfirm} variant="contained" color="error" autoFocus>
                Delete
            </Button>
        </DialogActions>
    </Dialog>
);

export default DeleteConfirmationDialog;
